import { Tags } from 'lucide-react';

export function TagManagementPage() {
  return (
    <div className="space-y-6">
      <div className="flex items-center gap-3">
        <Tags className="h-6 w-6 text-muted-foreground" />
        <h1 className="text-2xl font-semibold">Tag Management</h1>
      </div>
      <p className="text-muted-foreground">Coming soon — manage tag groups and tags for document classification.</p>
    </div>
  );
}
